<script setup>
import { ref } from 'vue';
import Commons from '../../shared/libraries/commons';
const matchData = ref(null);
</script>

<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SHOW_MATCH_DETAIL"
    :handler="
      (data) => {
        matchData = data;
        $refs.dialog.show();
      }
    "
  />
  <DialogComponent
    ref="dialog"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div v-if="matchData" class="">
      <!-- Header -->
      <div class="stficky top-0 bg-white z-10 px-6 py-4 border-b border-gray-100">
        <div class="flex items-center justify-between">
          <button @click="$refs.dialog.hide()" class="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
          <div class="text-center">
            <div class="text-sm text-gray-500">{{ Commons.time(matchData?.date, 'dddd D MMM') }}</div>
            <div class="text-lg font-bold text-gray-900">{{ matchData?.time || '-' }}</div>
          </div>
          <div class="w-10"></div>
        </div>
      </div>

      <!-- Teams Score Header -->
      <div class="bg-gradient-to-br from-gray-900 to-gray-800 px-6 py-8">
        <div class="flex items-center justify-between gap-4">
          <!-- Team 1 -->
          <div class="flex-1 text-center">
            <div class="w-16 h-16 mx-auto bg-white/10 rounded-2xl flex items-center justify-center mb-3">
              <ImgComponent
                :src="matchData?.team1?.logo"
                fallback="/images/match/t-shirt.svg"
                class="w-10 h-10 object-contain"
                alt=""
              />
            </div>
            <div class="text-white font-semibold text-sm line-clamp-2">
              {{ matchData?.team1?.name }}
            </div>
          </div>

          <!-- Score -->
          <div class="flex-shrink-0">
            <div class="bg-white/10 rounded-2xl px-6 py-3">
              <div class="flex items-center gap-3 text-3xl font-black text-white">
                <span>{{ matchData?.team1?.score ?? '-' }}</span>
                <span class="text-white/40">:</span>
                <span>{{ matchData?.team2?.score ?? '-' }}</span>
              </div>
            </div>
          </div>

          <!-- Team 2 -->
          <div class="flex-1 text-center">
            <div class="w-16 h-16 mx-auto bg-white/10 rounded-2xl flex items-center justify-center mb-3">
              <ImgComponent
                :src="matchData?.team2?.logo"
                fallback="/images/match/t-shirt.svg"
                class="w-10 h-10 object-contain"
                alt=""
              />
            </div>
            <div class="text-white font-semibold text-sm line-clamp-2">
              {{ matchData?.team2?.name }}
            </div>
          </div>
        </div>

        <!-- League -->
        <div v-if="matchData?.league" class="mt-6 text-center">
          <span class="inline-flex items-center px-3 py-1 bg-white/10 rounded-full text-white/80 text-sm">
            <svg class="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            {{ matchData.league }}
          </span>
        </div>
      </div>

      <!-- Content -->
      <div class="p-6 space-y-6">
        <!-- Match Info -->
        <div v-if="matchData?.location || matchData?.durationMin" class="bg-gray-50 rounded-2xl p-5">
          <div class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">
            Détails du match
          </div>
          <div class="space-y-4">
            <div v-if="matchData?.location" class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div>
                <div class="text-xs text-gray-500">Lieu</div>
                <div class="font-medium text-gray-900">
                  {{ matchData.location.city }}{{ matchData.location.country ? `, ${matchData.location.country}` : '' }}
                </div>
              </div>
            </div>
            <div v-if="matchData?.durationMin !== undefined" class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div>
                <div class="text-xs text-gray-500">Durée</div>
                <div class="font-medium text-gray-900">{{ matchData.durationMin }} minutes</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Odds -->
        <!-- <div>
          <div class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">
            Côtes principales
          </div>
          <div class="grid grid-cols-3 gap-3">
            <div
              v-for="quoteId in [
                { name: matchData?.team1?.name || 'Domicile', id: '1' },
                { name: 'Nul', id: 'X' },
                { name: matchData?.team2?.name || 'Extérieur', id: '2' }
              ]"
              :key="quoteId.name"
              class="bg-white border-2 border-gray-100 rounded-2xl p-4 text-center hover:border-primary/30 transition-colors"
            >
              <div class="text-xs text-gray-500 mb-1 line-clamp-1">{{ quoteId.name }}</div>
              <div class="text-2xl font-bold text-primary">
                {{ (matchData.quotes && matchData.quotes[quoteId.id]) || '-' }}
              </div>
            </div>
          </div>
        </div> -->

        <!-- All Odds -->
        <!-- <div v-if="matchData?.allOdds && Object.keys(matchData.allOdds).length > 0">
          <div class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">
            Toutes les côtes
          </div>
          <div class="bg-gray-50 rounded-2xl divide-y divide-gray-200">
            <div
              v-for="(odd, type) in matchData.allOdds"
              :key="type"
              v-show="!/inconnu/i.test(odd.description)"
              class="flex items-center justify-between p-4 last:rounded-b-2xl first:rounded-t-2xl"
            >
              <div class="flex-1 min-w-0">
                <div class="font-medium text-gray-900 truncate">{{ odd.description }}</div>
                <div class="text-xs text-gray-500 mt-0.5">
                  {{ odd.group }}
                </div>
              </div>
              <div class="ml-4 text-right">
                <div class="text-lg font-bold text-primary">{{ odd.value }}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </DialogComponent>
</template>
